  <template>
  <div v-loading="loading" v-if="locationDetails">
    <section class="resort-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 hotel-logo">
            <img src="../../assets/images/diplomat_logo.png" alt="logo hotel" />
            <h3 class="resort-title" v-html="locationDetails.name"></h3>
          </div>
          <!-- end .col-lg-12 -->
        </div>
        <!-- end .row -->
      </div>
      <!-- end .container -->
    </section>

    <!-- <section id="carousel" v-for="locationImage in locationImages" v-if="locationImage.slug === locationDetails.slug">
        <div class="container">
          <div class="row">
            <div class="col-lg-4" v-for="(image, index) in locationImage.images">
              <div class="resort-img" :style="'background-image: url(' + image + ')'"></div>
            </div>
          </div>
        </div>
      </section> -->

    <section class="location-details">
      <div class="container">
        <div class="row sectiom-reverse">
          <div class="col-lg-12">
            <!-- ///////////////// -->
            <!-- SEAT TYPE OPTIONS -->
            <!-- ///////////////// -->
            <div class="row">
              <div class="col-lg-12">
                <div class="available-cabana">
                  <div class="available-text">
                    The following cabana(s) are avaliable on
                  </div>
                  <!-- <el-date-picker
                  v-model="dateFrom"
                  type="date"
                  placeholder="Select booking date"
                  :picker-options="pickerOptions"
                  format="MM/dd/yyyy"
                  @change="handleDateClick"
                  >
                </el-date-picker> -->
                  <div class="available-data">
                    <el-date-picker
                      v-model="dateFromTo"
                      :picker-options="pickerOptions"
                      type="daterange"
                      format="MM/dd/yyyy"
                      range-separator=""
                      start-placeholder="Select Date(s)"
                      end-placeholder=""
                      @change="handleDateClick"
                    />
                  </div>
                </div>
                <div
                  class="result for-padding"
                  v-for="seatTypeOption in seatTypeOptions"
                  :key="seatTypeOption.id"
                >
                  <div v-if="seatTypeOption.is_available" class="row">
                    <div class="col-lg-5">
                      <span
                        v-if="
                          seatTypeOption &&
                          seatTypeOption.fileList &&
                          seatTypeOption.fileList.length
                        "
                      >
                        <el-carousel
                          :autoplay="autoplay"
                          :arrow="'never'"
                          :indicator-position="'outside'"
                          :trigger="'click'"
                          class="for-height"
                          :height="
                            imgHight > 767 && imgHight < 991
                              ? '400px'
                              : imgHight < 375 && imgHight > 319
                              ? '170px'
                              : '230px'
                          "
                        >
                          <el-carousel-item
                            v-for="item in seatTypeOption.fileList"
                            :key="item.name"
                          >
                            <el-image
                              class="medium"
                              :src="item.url"
                              :preview-src-list="[item.url]"
                            >
                            </el-image>
                          </el-carousel-item>
                        </el-carousel>
                      </span>
                    </div>
                    <!-- end .col-lg-5 -->
                    <div class="col-lg-7 pl-lg-0">
                      <div class="info-section-cabana">
                        <div class="row">
                          <div class="col-lg-12 for-pos-button">
                            <h3
                              class="resort-title"
                              v-html="seatTypeOption.name"
                            ></h3>
                            <div v-html="seatTypeOption.description"></div>
                            <div>
                              <el-row :gutter="20" class="wrap-price">
                                <el-col :span="imgHight>530?6:12" class="text-left">
                                  <strong
                                    >Full day<br /><b class="guest-price">{{
                                      seatTypeOption.starting_price
                                    }}</b></strong
                                  >
                                  <span v-if="seatTypeOption.seats_left_count <= 3" class="quantity-cabana"
                                    >ONLY
                                    {{ seatTypeOption.seats_left_count }}
                                    LEFT</span
                                  >
                                </el-col>
                                <div class="for-line"></div>
                                <el-col :span="imgHight>530?6:12">
                                  <strong
                                    >Up to<br /><b class="guest-price"
                                      >{{ seatTypeOption.max_guests }} guests</b
                                    ></strong
                                  >
                                </el-col> </el-row
                              ><br />
                              <div class="div-btn-book2">
                                <!-- <p v-html="seatTypeOption.timing"></p> -->
                                <el-button type="info" @click="handleOpenDialog(seatTypeOption)">Details</el-button>
                                <el-button type="primary" @click="handleBookNow(seatTypeOption.id)">Book Now!</el-button>
                              </div>
                              <!-- <br /><br /> -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end .resort-content -->
                    </div>
                    <!-- end .col-lg-7 -->
                  </div>
                  <!-- end .row -->
                </div>
                <!-- end .result -->
              </div>
              <!-- end .col-lg-12 -->
            </div>
            <!-- end .row -->

            <!-- ///////////////// -->
            <!-- LOCATION DETAILS -->
            <!-- ///////////////// -->
            <!-- <div v-html="locationDetails.description"></div> -->
          </div>
          <!-- end .col-lg-8 -->

          <!-- <div class="col-lg-4">
            <div id="resort-sidebar">
              <div class="passes">
                <div class="row" v-if="locationDetails.seat_types.length">
                  <div class="col-lg-6" v-for="seatType of locationDetails.seat_types">
                    <div class="pass text-center">
                      <strong v-html="seatType.seat_type"></strong>
                      <p>Starting At</p>
                      <p class="price">{{ seatType.seat_price_display }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- end .col-lg-4 -->
        </div>
        <!-- end .row -->
      </div>
      <!-- end .container -->

      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="40%"
        :before-close="handleClose">
        <span class="terms-editor" v-html="locationDetails.terms"></span>
        <span slot="footer" class="dialog-footer">
          <el-button type="warning" @click="handleClose">Close</el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>

  <script>
import { getLocationDetails, getSeatTypes } from "@/api/location";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";

export default {
  name: "Home",
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      imgHight: window.innerWidth,
      calendarPlugins: [
        dayGridPlugin,
        interactionPlugin, // needed for dateClick
      ],
      dialogVisible: false,
      dialogData: {},
      loading: false,
      autoplay: false,
      calendarWeekends: true,
      locationDetails: "",
      locationSlug: "",
      seatTypes: [],
      seatTypeOptions: [],
      locationImages: [
        {
          slug: "diplomat",
          images: [
            require("assets/images/diplo1.jpg"),
            require("assets/images/diplo2.jpg"),
            require("assets/images/diplo3.jpg"),
          ],
        },
        {
          slug: "legoland",
          images: [
            require("assets/images/lacan1.jpg"),
            require("assets/images/lacan2.jpg"),
            require("assets/images/lacan3.jpg"),
          ],
        },
      ],
      pickerOptions: {
        disabledDate(date) {
          const dated = moment(new Date()).format("YYYY-MM-DD");
          const comapare = moment(new Date(date)).format("YYYY-MM-DD");
          return new Date(dated) > new Date(comapare);
        },
      },
      dateFrom: '',
      dateTo: '',
      dateFromTo: ['', ''],
    };
  },
  created() {
    this.loading = true;
    this.locationSlug = this.$route.params.slug;
    if (this.$route.query.date_from) {
      this.dateFrom = moment(this.$route.query.date_from, "YYYY-MM-DD hh:mm:ss").format("MM/DD/YYYY hh:mm:ss");
    }
    if (this.$route.query.date_to) {
      this.dateTo = moment(this.$route.query.date_to, "YYYY-MM-DD hh:mm:ss").format("MM/DD/YYYY hh:mm:ss");
    }
    this.dateFromTo = [this.dateFrom, this.dateTo];
    this.handleLocationDetails(this.dateFrom, this.dateTo);
    window.addEventListener("resize", this.changeImgHeight);
  },
  methods: {
    handleOpenDialog(data) {
      this.dialogData = data;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    changeImgHeight() {
      this.imgHight = window.innerWidth;
    },
    handleDateClick(arg) {
      // this.dateFrom = moment(new Date(arg)).format("MM/DD/YYYY");
      this.handleLocationDetails(arg[0], arg[1]);
    },
    handleBookNow(seatTypeOptionId) {
		console.log(this.dateFrom);
		if(this.dateFrom == 'Invalid date' || this.dateTo == 'Invalid date'){
			alert('Please select your date(s)');
		}else{
			this.$router.push(
				"/reservations/" +
				this.locationSlug +
				"?" +
				"date_from=" +
				moment(this.dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss") +
				"&date_to=" +
				moment(this.dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss") +
				"&seat_type_option_id=" +
				seatTypeOptionId +
				"&t=" +
				this.getMilliseconds()
			);
		}
      
    },
    handleLocationDetails(dateFrom, dateTo) {
      var dateFrom = new Date(dateFrom);
      dateFrom = moment(dateFrom).format("YYYY-MM-DD");
      this.dateFrom = moment(dateFrom, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");

      var dateTo = new Date(dateTo);
      dateTo = moment(dateTo).format("YYYY-MM-DD");
      this.dateTo = moment(dateTo, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm:ss");

      this.loading = true;
      getLocationDetails(this.locationSlug, dateFrom, dateTo).then(
        (response) => {
          if (response.data.success == true) {
            this.locationDetails = response.data.data.locations[0];
            this.seatTypeOptions = response.data.data.seat_type_options;
            // this.getEvents(this.location.id);
          }
          this.loading = false;
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-price {
  display: flex;
}
.for-line {
  border: 1px solid #dcdfe6;
  height: 67px;
}
.hotel-logo {
  display: flex;
  align-items: center;
  img {
    width: 70px;
    @media only screen and (max-width: 480px) {
      width: 50px;
    }
  }
}
.available-cabana {
  border-top: 1px solid #dcdfe6;
  margin-top: 15px;
  padding-top: 25px;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 780px) {
    display: block;
  }
  .available-text {
    width: 40%;
    font-size: 20px;
    @media only screen and (max-width: 991px) {
      width: 70%;
    }
    @media only screen and (max-width: 780px) {
      width: 100%;
      margin-bottom: 20px;
      font-size: 16px;
    }
  }
  .available-data {
    width: 60%;
    @media only screen and (max-width: 780px) {
      width: 100%;
    }
  }
}
.info-section-cabana {
  padding: 0 20px;
}
.sectiom-reverse {
  flex-direction: row-reverse;
  @media only screen and (max-width: 991px) {
    flex-direction: column-reverse;
  }
}
.for-pos-button {
  // position: relative;
  .div-btn-book {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    width: 100%;
    @media only screen and (max-width: 600px) {
      display: block;
      padding-bottom: 15px;
    }
    p {
      margin: 0;
    }
    button {
      @media only screen and (max-width: 600px) {
        width: 100%;
      }
    }
  }
}
.for-padding {
  padding: 0 20px 0 0;
  border-radius: 6px;
  box-shadow: 0 0 10px 2px #e8e8e8;
  @media only screen and (max-width: 991px) {
    padding: 0;
  }
}
.for-height {
  border-top-left-radius: 6px;
  @media only screen and (max-width: 991px) {
    border-top-right-radius: 6px;
  }
  img {
    object-fit: cover;
  }
}
.medium {
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
}

.guest-price {
  font-size: 20px;
  display: block;
}
.quantity-cabana {
  color: #e6a23c;
  text-transform: uppercase;
}
#resort-sidebar h3 {
  @media only screen and (max-width: 420px) {
    font-size: 1.45rem;
  }
}
</style>



// WEBPACK FOOTER //
// details.vue?7c269a7f